<script setup>
import WorkflowTasksTab from "@/components/workflows/WorkflowTasksTab.vue";
import { onMounted, ref } from "vue";
import "vue3-toastify/dist/index.css";

const hasViewWorkflowTasksPermission = ref(false)

onMounted(() => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userPermissionsByRoles = userData.permissions_by_roles;
  const viewWorkflowTasksPermission = Object.values(
    userPermissionsByRoles
  ).some((permissions) => permissions.includes("View Workflow Tasks"));
  if (viewWorkflowTasksPermission) {
    hasViewWorkflowTasksPermission.value = true 
  }
});

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div>
    <VCard title="" class="">
      <VCardText class="p-0" style="padding: 0 !important">
        <div v-if="hasViewWorkflowTasksPermission" >
          <WorkflowTasksTab />
        </div>
      </VCardText>
    </VCard>
  </div>
</template>
